<template>
  <div>
    <Loading
      :show="isScreenLoading"
    />
    <div class="main-ttl container-xl">
      <h2>
        <span>{{ headingTitle }}</span>
        <small>{{ headingDesc }}</small>
      </h2>
    </div>

    <main class="container-xl">
      <div class="primary-area setting-area bg-none-sm">
        <HeaderSetting />

        <div class="outside-ttl-sm">
          <Breadcrumb v-if="crumbs.length" :crumbs="crumbs" />
          <div class="section-ttl list-btn-area">
            <h3>監視デバイス登録</h3>
          </div>
        </div>

        <section class="primary-section p-0-sm">
          <div class="line-area">
            <dl class="row section-item single-item">
              <dt class="col-md-3">
                <label class="col-form-label">
                  使用する監視デバイス<Icon type="required">必須</Icon>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  :class="{
                    'form-error': formErrors.monitoringDevice.getErrorMsg('productKey'),
                  }"
                  placeholder="AS-CMU監視デバイスIDを入力して下さい。"
                  v-model="mabeeemlMonitoringDevices.monitoringDevice.productKey"
                />
                <div class="small notes notes-error">
                  {{  formErrors.monitoringDevice.getErrorMsg('productKey') }}
                </div>
                <Tooltip
                  message="監視デバイスIDとは？"
                  :tipImage="images.BatteryImage"
                  tipImageAlt="製品番号のイメージ"
                >
                  <span>
                    AS-CMU本体中の通信ユニット「MabeeeML」に記載されている9桁の英数字番号です。
                  </span>
                </Tooltip>
              </dd>
            </dl>

            <dl class="row section-item single-item">
              <dt class="col-md-3">
                <label class="col-form-label">監視デバイスの管理名</label>
              </dt>
              <dd class="col-md-9">
                <Input
                  :class="{
                    'form-error': formErrors.monitoringDevice.getErrorMsg('name'),
                  }"
                  placeholder="管理しやすい名前を入力してください。"
                  v-model="mabeeemlMonitoringDevices.monitoringDevice.name"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  formErrors.monitoringDevice.getErrorMsg('name') }}
                </div>
              </dd>
            </dl>

            <dl class="section-item row">
              <dt class="col-md-3">
                <label class="col-form-label">
                  支払いサイクル
                </label>
              </dt>
              <dd class="col-md-9 row pay-cycle">
                <div class="col-md-4">
                  <input
                    id="pay-radio-01"
                    class="form-check-input cstm-input"
                    type="radio"
                    name="paymentCycle"
                    checked
                  />
                  <label class="pay-plan" for="pay-radio-01">
                    <div class="plan-ttl">12ヶ月払い</div>
                    <div class="sub-txt">
                      監視デバイス<br />1台あたりの利用料
                    </div>
                    <div class="plan-price">1,200<span>円/月</span></div>
                    <div class="sub-txt">年換算だと <span>14,400 円</span></div>
                  </label>
                </div>
                <Text
                  :notes="[
                    '※ 対応監視デバイス（別売）を当サービスに登録することで利用料が発生します。',
                  ]"
                />
              </dd>
            </dl>

            <dl class="section-item row">
              <dt class="col-md-3">
                <label class="col-form-label">
                  契約更新<Icon type="required">必須</Icon>
                </label>
              </dt>
              <dd class="col-md-9">
                <Switch
                  label="自動更新します"
                  :sublabel="this.autoRenewalSubLabel"
                  :true-value="AUTO_RENEWAL.ON"
                  :false-value="AUTO_RENEWAL.OFF"
                  v-model="ascmuSubscriptions.autoRenewal"
                />
              </dd>
            </dl>

            <dl class="row section-item">
              <ul class="btn-area reverse list-unstyleds">
                <li><Button variant="cancel" @click="showList">キャンセル</Button></li>
                <li><Button
                    :disabled="!isScreenActive"
                    @click="validate
                  ">
                  決定する</Button>
                </li>
              </ul>
            </dl>
          </div>
        </section>

        <AscmuSubscriptonsCreateConfirmModal
          modalId="testModal"
          ref="ascmuSubscriptionCreateConfirmModal"
          @confirm="submit"
        />

        <CancelBrowserBackModal
          modalId="cancel-browser-back-modal"
          ref="cancelBrowserBackModal"
        />

      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";

import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";
import { AUTO_RENEWAL } from "models/subscription";

import {
  Loading,
  Button,
  Breadcrumb2 as Breadcrumb,
  Icon,
  Input,
  Text,
  Switch,
  Tooltip,
  CancelBrowserBackModal,
} from "components";
import { BatteryImage } from "img";
import { HeaderSetting } from "containers";
import { TrashRedIcon } from "icons";

/* モーダル */
import {
  CreateConfirmModal as AscmuSubscriptonsCreateConfirmModal,
} from "components/ascmu-subscriptions";

/* コントローラ */
import {
  MabeeemlMonitoringDevicesController,
} from "controllers/mabeeeml-monitoring-devices";
import {
  AscmuSubscriptionsController,
} from "controllers/ascmu-subscriptions";
import { AscmuSubscription } from "models/ascmu-subscription";

import {
  MonitoringDevicesStoreValidator,
} from "validators/monitoring-devices";

/* カスタム例外 */
import { RepositoryError } from "repositories/repository";

const MabeeemlMonitoringDevicesRepository = RepositoryFactory.get("mabeeeml-monitoring-devices");

export default {
  name: "MonitoringDevicesCreate",
  components: {
    Loading,
    Button,
    Breadcrumb,
    HeaderSetting,
    Switch,
    Icon,
    Input,
    Text,
    Tooltip,
    AscmuSubscriptonsCreateConfirmModal,
    CancelBrowserBackModal,
  },
  data() {
    return {
      AUTO_RENEWAL,
      icons: {
        TrashRedIcon,
      },
      images: {
        BatteryImage,
      },
      headingTitle: "サービスアカウント設定",
      headingDesc: "サービスアカウントの登録情報です。",
      crumbs: [
        {
          label: "監視デバイス",
          routeName: "MonitoringDeviceList",
        },
        {
          label: "監視デバイス登録",
          routeName: null,
        },
      ],
      mabeeemlMonitoringDevices: new MabeeemlMonitoringDevicesController(),
      ascmuSubscriptions: new AscmuSubscriptionsController(),
      /* バリデーションエラー */
      formErrors: {
        monitoringDevice: new MonitoringDevicesStoreValidator(),
      },
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
    }),
    autoRenewalSubLabel() {
      const expireseDateStr = AscmuSubscription.getExpiresDateStr("YYYY/MM/DD");
      if (this.ascmuSubscriptions.autoRenewal === AUTO_RENEWAL.ON) {
        return `更新日：${expireseDateStr}`;
      }
      return `利用可能期間：${expireseDateStr} まで`;
    },
  },
  async created() {
    /* 初期化処理 */
    try {
      // 監視デバイス
      this.mabeeemlMonitoringDevices
        = await MabeeemlMonitoringDevicesController.createInstance(
          this.currentServiceAccount.serviceAccountId,
          this.currentAsigProject.asigProjectId,
        );
      // サブスクリプション情報の取得
      this.ascmuSubscriptions
        = await AscmuSubscriptionsController.createInstance(
          this.currentAsigProject.asigProjectId,
        );

      // 画面機能を有効化
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    } catch (err) {
      console.log(err);
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
  },
  mounted() {
    window.history.pushState(null, null, null);
    window.addEventListener("popstate", this.handlePopstate);
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this.handlePopstate);
  },
  methods: {
    handlePopstate() {
      window.history.pushState(null, null, null);
      this.$refs.cancelBrowserBackModal.openModal();
    },
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotificaton: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
    }),
    async validate() {
      try {
        /* 前処理 */
        // 画面機能を非アクティブにする
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        // 通知を初期化
        await this.resetNotificaton();
        /* バリデーション */
        this.formErrors.monitoringDevice = await this.mabeeemlMonitoringDevices.upsertValidate();

        if (
          !this.formErrors.monitoringDevice.result
        ) {
          // バリデーションがすべて通過しなければAPIの実行は行わず、画面機能をアクティブにする
          await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          this.confirm();
          await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        }
      } catch (err) {
        console.log(err);
        // 発生したエラー内容に応じたメッセージをユーザへお知らせ
        if (err instanceof RepositoryError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.server.${err.errorCd}`),
          });
        } else {
          this.setErrorNotification({
            message: "予期せぬエラーが発生しました。",
          });
        }
      }
    },
    async confirm() {
      this.$refs.ascmuSubscriptionCreateConfirmModal.openModal();
    },
    async submit() {
      try {
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.LOADING);

        // バリデーションにすべて成功していればAPIの実行を行う
        await this.mabeeemlMonitoringDevices.upsert();

        // サブスクリプション登録
        // 現在の監視設定に紐づく監視デバイスに対し、サブスクリプション登録を行う。
        // TODO: 制御を再確認する。　・・・なせここで再作成している？
        const ascmuSubscriptions = await AscmuSubscriptionsController.createInstance(
          this.currentAsigProject.asigProjectId,
          this.mabeeemlMonitoringDevices.getMonitoringDeviceId(),
        );
        ascmuSubscriptions.autoRenewal = this.ascmuSubscriptions.autoRenewal;
        // await this.ascmuSubscriptions.create();
        await ascmuSubscriptions.create();
        await MabeeemlMonitoringDevicesRepository.sendRegistrationNotification(
          this.currentAsigProject.asigProjectId,
          this.mabeeemlMonitoringDevices.getMonitoringDeviceId(),
        );

        this.$router.push({ name: "MonitoringDeviceList" });
        // await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      } catch (err) {
        console.log(err);
        // 発生したエラー内容に応じたメッセージをユーザへお知らせ
        if (err instanceof RepositoryError) {
          this.setErrorNotification({
            message: this.$t(`errors.api.server.${err.errorCd}`),
          });
        } else {
          this.setErrorNotification({
            message: "予期せぬエラーが発生しました。",
          });
        }
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    showList() {
      this.$router.push({
        name: "MonitoringDeviceList",
      });
    },
  },
};
</script>
